import type { MarketConfiguration } from '@/config/markets/const';

export default function getNorceCdnImageUrl(
    imageKey: string = '',
    market: MarketConfiguration,
) {
    if (!imageKey) return '';
    const url = market.norceImageCdn;
    if (imageKey.includes(url)) return imageKey;
    return `${url}/${imageKey}`;
}
